import { annoDimForRequest } from "../utils/annoDimForRequest";

export const TimeSeriesWidget_processRawConfigFn = (_widgetConfig) => {
  let contentType;
  let dateValuePath;
  let dateValuePathByContentType;
  let dimensionValuePath = null;
  let presetActiveFilters = [];
  let breakdownCategoryName;
  
  const dateField = _widgetConfig.props?.dateField;
  const dimension = _widgetConfig.props?.dimension;
  const interval = _widgetConfig.props?.interval || { display: "Day", value: "day" };
  const cyclical = _widgetConfig.props?.cyclical || { display: "No", value: false };
  const selectedTimeRange = _widgetConfig.props?.selectedTimeRange || { display: "All Data", value: "all" };
  
  // Validate required fields
  if (!dateField) {
    return _widgetConfig; // Return as-is if date field is missing
  }
  
  // Process date field
  // Date fields are standard fields: { contentType, valuePath, display }
  contentType = dateField.contentType;
  dateValuePath = dateField.valuePath;
  
  // Process optional dimension
  if (dimension) {
    // Set breakdown category name
    breakdownCategoryName = dimension.display;

    // Process dimension based on its type
    const isAnnoDimension =
      dimension.dimensionType === "topicClusteringNode" ||
      dimension.isAnno === true ||
      String(dimension.valuePath || "").startsWith("annotations.");
    if (isAnnoDimension) {
      // Annotation-based dimensions (tags, sub-themes and their drills, topics
      // and sub-topics): the series is counted on the annotations collection,
      // bucketed on the chosen dataset's date as it is denormalized onto each
      // annotation (main.* copy, ISO string) — the "date that matters"
      // contract the Lenses widgets use. Request shapes are the Bar widget's.
      contentType = "annotations";
      dateValuePathByContentType = { [dateField.contentType]: { valuePath: dateField.valuePath, dateAsString: true } };
      dateValuePath = undefined;
      if (dimension.rollupType === "tagType") {
        dimensionValuePath = {
          rollupType: dimension.rollupType,
          path: dimension.rollupPath,
          isAnno: true,
          ...(dimension.restrictBucketValues ? { restrictBucketValues: dimension.restrictBucketValues } : {}),
        };
      } else {
        // plain tag field, sub-theme drill (restrictBucketsByRollup) or topics
        dimensionValuePath = annoDimForRequest(dimension);
      }
    } else if (dimension.isExpression) {
      // Handle arithmetic expression dimensions
      // Backend expects blockValuePath for expression parsing
      dimensionValuePath = {
        blockValuePath: dimension.valuePath,
        isExpression: true
      };
    } else if (!dimension.rollupType) {
      // Standard field (tag, checkbox, dropdown, etc.)
      // Regular field from content type
      dimensionValuePath = dimension.valuePath;
    } else if (dimension.rollupType === "tagType") {
      // Rollup by tag type
      dimensionValuePath = {
        rollupType: dimension.rollupType,
        path: dimension.rollupPath
      };
    } else if (dimension.rollupType === "valuePathType") {
      // Rollup by value path
      dimensionValuePath = {
        rollupType: dimension.rollupType,
        path: [dimension.tagTypeCollectionToRollup, dimension.blockValuePath]
      };
    }

    // Add preset active filters if they exist
    if (dimension.presetActiveFilters) {
      presetActiveFilters = [...presetActiveFilters, ...dimension.presetActiveFilters];
    }
  }
  
  const toReturn = {
    ..._widgetConfig,
    props: {
      ..._widgetConfig.props,
      contentType,
      dateValuePath,
      dateValuePathByContentType,
      dimensionValuePath,
      interval,
      cyclical,
      selectedTimeRange,
      presetActiveFilters,
      ...(breakdownCategoryName ? { breakdownCategoryName } : {}),
      // Pass through hidden datapoints for show/hide feature
      hiddenDimDatapoints: _widgetConfig.props?.hiddenDimDatapoints || [],
      dimVisibilityPreset: _widgetConfig.props?.dimVisibilityPreset || "all",
      dimVisibilityN: _widgetConfig.props?.dimVisibilityN,
    },
  };
  
  return toReturn;
};

export const TimeSeriesWidget_someReqPropsUnset = (widgetConfig) => {
  return !widgetConfig?.props?.dateField;
};